import {
  NativeResultDTO,
  NativeConfDto,
  NativeFileUploadDto,
  NativeOrientationDto,
  NativeLocationDto,
  NativePushTokenDto,
  NativePushMessageDto,
  NativeAppInfoDto,
  NativeBarcodeDto,
  NativePictureDto,
} from '../../dto';
import { NativeComm } from '../../comm';

const nativeComm = new NativeComm();



export function saveConf(
  conf: NativeConfDto,
): Promise<NativeResultDTO<NativeConfDto>> {
  return nativeComm.call<NativeConfDto>('saveConf', [conf]);
}

export function loadConf(): Promise<NativeResultDTO<NativeConfDto>> {
  return nativeComm.call<NativeConfDto>('loadConf', []);
}

export function uploadFile(
  uploadUrl: String,
): Promise<NativeResultDTO<NativeFileUploadDto>> {
  return nativeComm.call<NativeFileUploadDto>('uploadFile', [uploadUrl, false]);
}

export function beginOrientation(
  handler: (data: NativeOrientationDto) => void,
): Promise<NativeResultDTO<NativeOrientationDto>> {
  return nativeComm.beginStream<NativeOrientationDto>(
    'beginOrientation',
    [],
    handler,
  );
}

export function endOrientation(
  beginPromise: Promise<NativeResultDTO<NativeOrientationDto>>,
): Promise<NativeResultDTO<any>> {
  return nativeComm.endStream<any>('endOrientation', beginPromise);
}

export function beginBackkey(
  handler: () => boolean,
): Promise<NativeResultDTO<any>> {
  //return nativeComm.beginStream<any>('beginBackkey', [], ()=>(handler()?'true': 'false';));
  return nativeComm.beginStream<any>('beginBackkey', [], handler);
}

export function endBackkey(
  beginPromise: Promise<NativeResultDTO<any>>,
): Promise<NativeResultDTO<any>> {
  return nativeComm.endStream<any>('endBackkey', beginPromise);
}

export function beginLocation(
  handler: (data: NativeLocationDto) => void,
): Promise<NativeResultDTO<NativeLocationDto>> {
  return nativeComm.beginStream<NativeLocationDto>(
    'beginLocation',
    [],
    handler,
  );
}

export function endLocation(
  beginPromise: Promise<NativeResultDTO<NativeLocationDto>>,
): Promise<NativeResultDTO<any>> {
  return nativeComm.endStream<any>('endLocation', beginPromise);
}

export function launchUrl(url: String): Promise<NativeResultDTO<any>> {
  return nativeComm.call<any>('launchUrl', [url]);
}

export function getPushToken(): Promise<NativeResultDTO<NativePushTokenDto>> {
  return nativeComm.call<NativePushTokenDto>('getPushToken', []);
}

export function beginPushToken(
  handler: (data: NativePushTokenDto) => void,
): Promise<NativeResultDTO<NativePushTokenDto>> {
  return nativeComm.beginStream<NativePushTokenDto>(
    'beginPushToken',
    [],
    handler,
  );
}

export function endPushToken(
  beginPromise: Promise<NativeResultDTO<NativePushTokenDto>>,
): Promise<NativeResultDTO<any>> {
  return nativeComm.endStream<any>('endPushToken', beginPromise);
}

export function beginPushMessage(
  handler: (data: NativePushMessageDto) => void,
): Promise<NativeResultDTO<NativePushMessageDto>> {
  return nativeComm.beginStream<NativePushMessageDto>(
    'beginPushMessage',
    [],
    handler,
  );
}

export function endPushMessage(
  beginPromise: Promise<NativeResultDTO<NativePushMessageDto>>,
): Promise<NativeResultDTO<any>> {
  return nativeComm.endStream<any>('endPushMessage', beginPromise);
}

export function getAppInfo(): Promise<NativeResultDTO<NativeAppInfoDto>> {
  return nativeComm.call<NativeAppInfoDto>('getAppInfo', []);
}

export function hideKeyboard(): Promise<NativeResultDTO<any>> {
  return nativeComm.call<any>('hideKeyboard', []);
}

export function setEventOnInBG(on: boolean): Promise<NativeResultDTO<any>> {
  return nativeComm.call<any>('setEventOnInBG', [on]);
}

export function scanBarcode(): Promise<NativeResultDTO<NativeBarcodeDto>> {
  return nativeComm.call<NativeBarcodeDto>('scanBarcode', []);
}


export function takePicture(): Promise<NativeResultDTO<NativePictureDto>> {
  return nativeComm.call<NativePictureDto>('takePicture', []);
}

export function purchaseSubscription(accessToken: String, productId: String | null, planId: String | null, upgrade: 'up'|'down'|null): Promise<NativeResultDTO<any>> {
  return nativeComm.call<any>('purchaseSubcription', [accessToken, productId, planId, upgrade]);
}
